export default __webpack_public_path__ + "static/media/aedrian-ECt01A5HZtw-unsplash.aa6c9718.jpg";